<template>
  <div class="header-menu tw-h-16 lg:tw-h-16 md:tw-h-32">
    <div class="top-menu">
      <div
        class="tw-w-full tw-hidden lg:tw-h-16 md:tw-h-32 tw-bg-white md:tw-flex tw-shadow-sm xl:tw-px-36 lg:tw-px-10 md:tw-px-10"
      >
        <div class="tw-h-16 tw-flex tw-flex-none tw-items-center">
          <a href="/">
            <img class="tw-h-10" src="@/static/staimg/tiansheng.png" alt />
          </a>
        </div>
        <div
          class="tw-absolute lg:tw-static tw-left-0 tw-top-16 tw-pl-8 tw-flex tw-items-center tw-h-16 tw-flex-none tw-gap-8 lg:tw-gap-7 xl:tw-gap-8 tw-text-sm tw-cursor-pointer tw-text-textMain"
        >
          <span
            v-for="item in leftMenu"
            :key="item.id"
            :class="{
              'tw-text-primary': $route.path.startsWith(
                item.activePattern || item.path,
              ),
            }"
            class="hover:tw-text-primary"
            @click="handleClickRoute(item.path)"
            >{{ item.name }}</span
          >
        </div>
        <div
          class="tw-flex tw-items-center tw-flex-1 tw-h-16 tw-justify-end xl:tw-gap-4 tw-gap-3"
        >
          <TopSearch @onSearch="getEnter" />
          <LanguageSwitcher />
          <!-- 购物车 -->
          <div
            class="tw-h-full tw-flex tw-justify-center tw-items-center tw-cursor-pointer"
            @click="handleClickRoute('/controlCenter/shopping-cart')"
          >
            <b-icon icon="cart" class="tw-text-xl"></b-icon>
          </div>

          <!-- 通知 -->
          <Notification></Notification>

          <div class="tw-flex tw-items-center tw-cursor-pointer tw-flex-none">
            <template v-if="userInfo && userInfo.id !== null">
              <UserInfo
                @outLogin="handleLoginOut"
                @open-api-auth="handleModal(true)"
              ></UserInfo>
            </template>
            <template v-else>
              <b-link
                class="user-login"
                @click="handleClickRoute('/login')"
                type="primary"
                size="sm"
              >
                {{ $t("登录") }}
              </b-link>
              <b-link
                class="user-login"
                @click="handleClickRoute('/register')"
                type="primary"
                size="sm"
              >
                {{ $t("注册") }}
              </b-link>
            </template>
          </div>
        </div>
      </div>

      <!-- 移动端头部  -->
      <div
        class="mobile tw-flex md:tw-hidden tw-h-16 tw-bg-white tw-items-center tw-justify-between tw-px-4"
      >
        <a href="/">
          <img class="tw-h-10" src="@/static/staimg/tiansheng.png" alt />
        </a>
        <div
          class="tw-absolute tw-left-28 tw-pl-4 tw-flex tw-items-center tw-h-16 tw-flex-none tw-gap-8 tw-text-sm tw-cursor-pointer tw-text-textMain"
        >
          <span
            v-for="item in mobileLeftMenu"
            :key="item.id"
            :class="{
              'tw-text-primary': $route.path.startsWith(
                item.activePattern || item.path,
              ),
            }"
            class="hover:tw-text-primary"
            @click="handleClickRoute(item.path)"
            >{{ item.name }}</span
          >
        </div>
        <div class="tw-flex tw-items-center">
          <div
            v-if="false"
            class="tw-ml-5 tw-flex tw-items-center tw-cursor-pointer tw-flex-none user-header"
          >
            <template v-if="userInfo && userInfo.id !== null">
              <img
                :src="userInfo.avatar "
                style="width: 28px; height: 28px; border-radius: 14px"
                alt
              />
            </template>
            <template v-else>
              <b-dropdown
                ref="dropdown2"
                size="sm"
                variant="ligth"
                no-caret
                toggle-class="text-decoration-none"
              >
                <template #button-content>
                  <b-icon
                    icon="person-circle"
                    style="width: 28px; height: 28px; color: #333"
                    @click="$refs.dropdown2.show()"
                  ></b-icon>
                </template>
                <b-dropdown-item href="#" @click="handleClickRoute('/login')">{{
                  $t("登录")
                }}</b-dropdown-item>
                <b-dropdown-item
                  href="#"
                  @click="handleClickRoute('/register')"
                  >{{ $t("注册") }}</b-dropdown-item
                >
              </b-dropdown>
            </template>
          </div>

          <div
            class="menu-icon tw-ml-5 tw-w-7 tw-h-5 tw-flex tw-flex-col tw-justify-between tw-cursor-pointer"
            :class="{ open: openMenu }"
            @click="handleClickMenu"
          >
            <span class="menu-line tw-w-full tw-h-0.5 tw-bg-black"></span>
            <span class="menu-line tw-w-full tw-h-0.5 tw-bg-black"></span>
            <span class="menu-line tw-w-full tw-h-0.5 tw-bg-black"></span>
          </div>
        </div>
      </div>
    </div>
    <!-- 移动端菜单  -->
    <b-sidebar
      sidebar-class="sidebar-menu"
      v-model="openMenu"
      no-header
      width="100%"
    >
      <div class="tw-flex tw-w-full tw-h-full tw-bg-white tw-overflow-hidden">
        <div
          class="tw-flex tw-flex-col tw-w-32 tw-flex-none tw-bg-bgMain tw-text-sm tw-pt-4 tw-text-textMain"
        >
          <span
            v-for="item in leftMenuWithUser"
            :key="item.id"
            :class="{
              'menu-active': mobileMenuSelect?.path?.startsWith(item.path),
            }"
            class="tw-p-3 tw-cursor-pointer"
            @click="handleMobileMenu(item)"
            >{{ item.name }}</span
          >
        </div>
        <div
          class="tw-flex-1 tw-h-full tw-bg-white tw-flex-col tw-overflow-auto"
        >
          <div
            class="tw-flex tw-flex-col tw-px-4"
            v-if="!mobileMenuSelect.hasChild"
          >
            <span class="tw-text-base tw-text-textMain tw-font-bold tw-py-3">{{
              mobileMenuSelect.name
            }}</span>
            <span
              class="tw-text-sm tw-text-textLight tw-py-2"
              @click="handleClickRoute(mobileMenuSelect.path)"
            >
              {{ mobileMenuSelect.name }}
            </span>
          </div>
          <div class="tw-flex tw-flex-col" v-else>
            <MobileProductMenu
              v-if="mobileMenuSelect.id === 2"
              @handleToDetail="handleDropdownLeave"
            />
            <MobileSolutionMenu
              v-if="mobileMenuSelect.id === 3"
              @handleToDetail="handleDropdownLeave"
            />
            <MobileDocumentMenu
              v-if="mobileMenuSelect.id === 4"
              @handleToDetail="handleDropdownLeave"
            />
            <MobileSupportMenu
              v-if="mobileMenuSelect.id === 5"
              @handleToDetail="handleDropdownLeave"
            />
            <MobilePersonalMenu
              v-if="mobileMenuSelect.id === 9"
              @handleToDetail="handleDropdownLeave"
            />
          </div>
        </div>
      </div>
    </b-sidebar>

    <b-sidebar
      sidebar-class="sidebar-menu"
      v-model="openSearch"
      no-header
      width="100%"
    >
      <MobileSearch @onSearch="getEnter" @onCloseSearch="openSearch = false" />
    </b-sidebar>
    <api-work-auth-modal
      :show="modalShow"
      @update:show="handleModal"
      @close="handleModal(false)"
    ></api-work-auth-modal>
  </div>
</template>
<script>
import { mapState } from "vuex";
import {
  indexApi,
  logoutApi,
  getUserInfoApi,
  documentCategoriesApi,
} from "@/api/modules/home";
import BaseLayout from "../BaseLayout.vue";
import TopSearch from "./TopSearch.vue";
import UserInfo from "./UserInfo.vue";
import MobileSearch from "./MobileSearch.vue";
import MobileSupportMenu from "./MobileSupportMenu.vue";
import MobileDocumentMenu from "./MobileDocumentMenu.vue";
import MobileSolutionMenu from "./MobileSolutionMenu.vue";
import MobileProductMenu from "./MobileProductMenu.vue";
import MobilePersonalMenu from "./MobilePersonalMenu.vue";
import ApiWorkAuthModal from "./components/ApiWorkAuthModal.vue";
import Notification from "./notification.vue";
import LanguageSwitcher from "@/components/LanguageSwitcher.vue";
import { goToBlockWatch, goToOfficialWebsite } from "@/utils/domain";
export default {
  name: "ControlTop",
  components: {
    BaseLayout,
    TopSearch,
    UserInfo,
    MobileSearch,
    ApiWorkAuthModal,
    MobileSupportMenu,
    MobileDocumentMenu,
    MobileSolutionMenu,
    MobileProductMenu,
    MobilePersonalMenu,
    Notification,
    LanguageSwitcher,
  },
  data() {
    return {
      modalShow: false,
      showKey: 0,
      openSearch: false,
      openMenu: false,
      userInfo: {},
      mobileMenuSelect: {},
      leftMenu: [
        {
          id: 1,
          name: this.$t("BLOCKWATCH工作台"),
          path: "/apiWord/api-console",
          hasChild: true,
          activePattern: "/apiWord",
        },
        {
          id: 2,
          name: this.$t("云服务工作台"),
          path: "/cloudWord/cloud-word",
          hasChild: true,
          activePattern: "/cloudWord",
        },
      ],
      leftMenuWithUser: [
        {
          id: 1,
          name: this.$t("RWA"),
          path: "/rwa",
          hasChild: false,
        },
        {
          id: 2,
          name: this.$t("产品"),
          path: "/product",
          hasChild: true,
        },
        {
          id: 3,
          name: this.$t("解决方案"),
          path: "/solution",
          hasChild: true,
        },
        {
          id: 10,
          name: this.$t("案例库"),
          path: "/dapp-shop",
          hasChild: false,
        },
        {
          id: 4,
          name: this.$t("文档"),
          path: "/document",
          hasChild: true,
        },
        {
          id: 5,
          name: this.$t("支持与服务"),
          path: "/supportAndServices",
          hasChild: true,
        },
        {
          id: 6,
          name: this.$t("了解天晟"),
          path: "/company",
          hasChild: false,
        },
        {
          id: 7,
          name: this.$t("最新动态"),
          path: "/dynamics",
          hasChild: false,
        },
        {
          id: 8,
          name: this.$t("合作伙伴"),
          path: "/partner",
          hasChild: false,
        },
        {
          id: 9,
          name: this.$t("个人中心"),
          path: "/controlCenter",
          hasChild: true,
        },
      ],
    };
  },
  watch: {
    openMenu(newVal) {
      if (newVal) {
        document.body.style.overflow = "hidden";
        document.documentElement.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
        document.documentElement.style.overflow = "";
      }
    },
    openSearch(newVal) {
      if (newVal) {
        document.body.style.overflow = "hidden";
        document.documentElement.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
        document.documentElement.style.overflow = "";
      }
    },
  },
  computed: {
    // 添加移动端专用菜单
    mobileLeftMenu() {
      return this.leftMenu.map((item) => {
        // 为移动端简化名称
        if (item.name === this.$t("BLOCKWATCH工作台")) {
          return {
            ...item,
            name: this.$t("BLOCKWATCH"), // 移动端只显示"API"
          };
        } else if (item.name === this.$t("云服务工作台")) {
          return {
            ...item,
            name: this.$t("云服务"), // 移动端只显示"云服务"
          };
        }
        return item;
      });
    },
    current() {
      return this.$store.state.isType;
    },
    isVerification() {
      return this.$store.state.isVerification;
    },
    // 当前路由名称
    routName() {
      return this.$route.name;
    },
    ...mapState(["isSearch"]),
  },
  beforeDestroy() {
    // 搜索
    if (this.routName !== "search") {
      this.$store.commit("SET_ISSEARCH", "");
    }
  },
  created() {
    this.getUser();
    this.getIndex();
    this.getDocumentCategories();
  },
  mounted() {
    window.addEventListener("scroll", () => {
      // 当前滚动位置
      let currentScrollPosition = window.scrollY;
      if (currentScrollPosition > this.lastScrollTop) {
        this.isShowTop = true;
      } else if (currentScrollPosition < this.lastScrollTop) {
        this.isShowTop = false;
      }
      this.lastScrollTop = currentScrollPosition;
    });
  },
  methods: {
    // 获取用户信息接口

    async getUser() {
      if (localStorage.getItem("userInfo")) {
        this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
        return;
      }
      const { code, data } = await getUserInfoApi();
      if (code !== 0) return;
      localStorage.setItem("userInfo", JSON.stringify(data));
      this.userInfo = data;
    },
    handleClickMenu() {
      this.openMenu = !this.openMenu;
      if (this.openMenu) {
        this.openSearch = false;
      }
      const path = this.$route.matched[0].path;
      if (!path) {
        this.mobileMenuSelect = this.leftMenuWithUser[0];
      } else {
        const menu = this.leftMenuWithUser.find((item) => item.path == path);
        this.mobileMenuSelect = menu || this.leftMenuWithUser[0];
      }
    },
    handleClickSearch() {
      this.openSearch = !this.openSearch;
      if (this.openSearch) {
        this.openMenu = false;
      }
    },
    handleMobileMenu(item) {
      this.mobileMenuSelect = item;
    },
    // 新增：鼠标离开下拉菜单区域
    handleDropdownLeave() {
      this.showKey = 0;
      this.openMenu = false;
    },
    getIndex() {
      indexApi().then((res) => {
        this.$emit("indexInfo", res.data);
        this.$store.commit("SET_INDEXINFO", res.data);
        localStorage.setItem("indexInfo", JSON.stringify(res.data));
      });
    },
    // 搜索框按回车触发
    getEnter(a) {
      this.$store.commit("SET_ISSEARCH", a);
      this.$router.push({
        name: "search",
        params: {
          name: a,
        },
      });
    },

    // 获取文档类别
    getDocumentCategories() {
      documentCategoriesApi({
        pageIndex: 1,
        pageSize: 999,
      }).then((res) => {
        let children =
          res.data && res.data.list
            ? res.data.list.map((item1) => {
                return { route: "/document", ...item1 };
              })
            : [];

        // 将 id 为 6 的项移到数组最后
        const index = children.findIndex((item) => item.id === 6);
        if (index !== -1) {
          const item = children.splice(index, 1)[0];
          children.push(item);
        }
        localStorage.setItem("documentCategories", JSON.stringify(children));
      });
    },

    // 页面跳转
    handleClickRoute(routeName) {
      if (
        routeName === "/apiWord/api-console" &&
        this.routName === "api-console"
      )
        return;

      if (routeName === "/apiWord/api-console" && this.isVerification === "0") {
        this.handleModal(true);
        return;
      }
      if (
        this.$route.path == routeName ||
        typeof routeName !== "string" ||
        !routeName.includes("/")
      )
        return;
      this.showKey = 0;
      if (routeName === "/apiWord/api-console") {
        goToBlockWatch("/apiWord/api-console");
      } else {
        goToOfficialWebsite(routeName);
      }
    },

    // 进入api工作台再次验证登录
    handleModal(show) {
      this.modalShow = show;
    },

    // 退出
    async handleLoginOut() {
      try {
        await logoutApi();
      } catch (error) {
        console.warn("退出登录接口调用失败，已清理本地登录状态", error);
      } finally {
        localStorage.removeItem("userInfo");
        localStorage.removeItem("token");
        this.$store.commit("SET_LOGIN", false);
        this.$store.commit("SET_VERIFICATION", "0");

        if (this.$route.path.includes("apiWord")) {
          goToOfficialWebsite("/?clearCache=true");
        } else {
          this.$router.push("/");
        }
      }
    },
    handleClickAvatar() {
      this.$refs.dropdown.show();
    },
  },
};
</script>
<style scoped lang="scss">
// 固定在顶部
.top-menu {
  position: fixed;
  top: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  z-index: 100;
}

.imglogo {
  height: 36px;
  object-fit: contain;
}

.user-login {
  line-height: 38px;
  padding: 0 15px;
  color: #000;
  text-decoration: none;
  font-size: 14px;

  &:hover {
    cursor: pointer;
    background: #2878ff;
    color: #fff;
  }
}

.menu-icon {
  .menu-line {
    transition: all 0.3s ease-in-out;
    transform-origin: center;
  }
}

.menu-icon.open {
  .menu-line:nth-child(1) {
    transform: translateY(9px) rotate(45deg);
  }

  .menu-line:nth-child(2) {
    opacity: 0;
    transform: scale(0);
  }

  .menu-line:nth-child(3) {
    transform: translateY(-9px) rotate(-45deg);
  }
}
::v-deep .b-sidebar {
  top: 64px;
}
::v-deep .sidebar-menu {
  background-color: #fff !important;
}

::v-deep .dropdown-menu {
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.05);
  border: none;
}

.menu-active {
  position: relative;
  @apply tw-text-primary tw-bg-white;
}

.menu-active::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 2px;
  height: 100%;
  background-color: #4077f8;
}

.user-header {
  ::v-deep .btn-sm,
  .btn-group-sm > .btn {
    padding: 0 !important;
  }
}
</style>
